import { render, staticRenderFns } from "./Ckck.vue?vue&type=template&id=4d12775b&scoped=true&"
import script from "./Ckck.vue?vue&type=script&lang=js&"
export * from "./Ckck.vue?vue&type=script&lang=js&"
import style0 from "./Ckck.vue?vue&type=style&index=0&id=4d12775b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d12775b",
  null
  
)

export default component.exports